module.exports = __webpack_public_path__ + "static/media/download.ea1ea03c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.svg
// module id = 594
// module chunks = 0